import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-integer-type',
  template: `
    <div class="field p-fluid mb-3 mt-1">
      <div
        *ngIf="
          props &&
            props.attributes &&
            props.attributes['slider'] &&
            field.templateOptions.min &&
            field.templateOptions.max;
          else inputField
        "
        class="pt-2"
      >
        <p-slider
          [step]="
            props.attributes['step'] ? +props.attributes['step'] : 1
          "
          [formControl]="formControl"
          [formlyAttributes]="field"
          [min]="field.templateOptions.min"
          [max]="field.templateOptions.max"
        ></p-slider>
        <p class="text-center mt-2">
          {{
            formControl.value
              ? formControl.value
              : field.templateOptions.min
          }}
        </p>
      </div>
      <div
        *ngIf="showError && formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>
      <div
        *ngIf="
          field.templateOptions.description &&
          (!showError || !formControl.errors)
        "
        class="text-sm mt-2"
      >
        {{ field.templateOptions.description }}
      </div>

      <ng-template #inputField>
        <p-inputNumber
          [formControl]="formControl"
          [formlyAttributes]="field"
          [min]="field.templateOptions.min"
          [max]="field.templateOptions.max"
        ></p-inputNumber>
      </ng-template>
    </div>
  `,
})
export class IntegerTypeComponent extends FieldType<FieldTypeConfig> {}
